module.exports = __webpack_public_path__ + "fonts/Roboto-Medium.e73e917.ttf";